import { HeaderBreadcrumb } from 'common/ui/Header';
import { Paths } from 'services/navigation/paths';
import { SourcingInternalStep } from '../stores/step-components/sourcingInternalStepComponents';
import { scrollToTop } from 'common/utils/scrollToTop';

type GetSourcingInternalHeaderBreadcrumbsProps = {
  candidateBatchJobTitle: string;
  candidateBatchId: string;
  setStep: (step: SourcingInternalStep) => void;
};

// Breadcrumbs for the sourcing internal header
// Analyse name -> Takes you to the analyse details page
// Candidates -> Takes you to the choose analysis step
// Invite to apply -> Takes you to the selected candidates step
export const getSourcingInternalHeaderBreadcrumbs = ({
  candidateBatchJobTitle,
  candidateBatchId,
  setStep
}: GetSourcingInternalHeaderBreadcrumbsProps): HeaderBreadcrumb[] => {
  return [
    {
      name: candidateBatchJobTitle,
      path: `${Paths.ANALYSE}/${candidateBatchId}`
    },
    {
      name: 'Candidates',
      action: () => {
        scrollToTop();
        // TODO: Navigate to search candidate profiles
        // setStep('CHOOSE_ANALYSIS');
      }
    },
    {
      name: 'Invite to apply',
      action: () => {
        scrollToTop();
        setStep('SELECTED_CANDIDATES');
      }
    }
  ];
};
